import { defineComponent as r, useTemplateRef as d, computed as o, createElementBlock as n, openBlock as a, mergeProps as c, unref as i, createVNode as f, createCommentVNode as m, toDisplayString as p } from "vue";
import { useBindCx as u } from "@scalar/use-hooks/useBindCx";
import { variants as h } from "./variants.js";
import { useTooltip as b } from "../ScalarTooltip/useTooltip.js";
import g from "../ScalarIcon/ScalarIconLegacyAdapter.vue.js";
const v = ["aria-disabled"], k = {
  key: 0,
  class: "sr-only"
}, y = {}, S = /* @__PURE__ */ r({
  ...y,
  inheritAttrs: !1,
  __name: "ScalarIconButton",
  props: {
    label: {},
    icon: {},
    disabled: { type: Boolean },
    variant: { default: "ghost" },
    size: {},
    thickness: {},
    weight: {},
    tooltip: { type: Boolean }
  },
  setup(t) {
    const { cx: s } = u(), l = d("ref");
    return b({
      content: o(() => t.label),
      offset: o(() => t.variant === "ghost" ? 0 : 4),
      placement: o(
        () => typeof t.tooltip == "boolean" ? void 0 : t.tooltip
      ),
      targetRef: o(() => t.tooltip ? l.value : void 0)
    }), (e, B) => (a(), n("button", c({
      ref: "ref",
      "aria-disabled": e.disabled,
      type: "button"
    }, i(s)(i(h)({ size: e.size, variant: e.variant, disabled: e.disabled }))), [
      f(i(g), {
        icon: e.icon,
        thickness: e.thickness,
        weight: e.weight
      }, null, 8, ["icon", "thickness", "weight"]),
      e.tooltip ? m("", !0) : (a(), n("span", k, p(e.label), 1))
    ], 16, v));
  }
});
export {
  S as default
};
